import { Media, Program, Role } from '@/types';
import { SearchResult, SearchTypes } from '@/types/search';

export class SearchResultEntity {
  [SearchTypes.Media]: Media[];
  [SearchTypes.Program]: Program[];
  [SearchTypes.Role]: Role[];

  constructor(search: SearchResult[]) {
    this[SearchTypes.Media] = search.find(({ doc_type }) => doc_type === SearchTypes.Media)
      ?.items as Media[];
    this[SearchTypes.Program] = search.find(({ doc_type }) => doc_type === SearchTypes.Program)
      ?.items as Program[];
    this[SearchTypes.Role] = search.find(({ doc_type }) => doc_type === SearchTypes.Role)
      ?.items as Role[];
  }
}
